import { render } from "./VersionManagement.vue?vue&type=template&id=57d3fafc"
import script from "./VersionManagement.vue?vue&type=script&lang=js"
export * from "./VersionManagement.vue?vue&type=script&lang=js"

import "./VersionManagement.vue?vue&type=style&index=0&id=57d3fafc&lang=scss"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__